const riot = require('riot');

riot.tag2('page-raffle_events-single', '<div class="s-full min-height-100per" if="{event}"> <div class="f fclm s-full px16 py24 overflow-y-scroll"> <div class="container-538"> <div if="{!hasResult()}"> <div if="{!isAfterPeriod}"> <div class="w-full mb24 {\'square\': !refs.general_image.complete}" if="{event.raffle_rule.image_url}"><img class="block w-full object-fit-contain" ref="general_image" riot-src="{event.raffle_rule.image_url}" alt="メイン画像" onload="{_.noop}"></div> <div class="text-center mb16"> <div class="ts-ps text-gray_80" if="{event.raffle_rule.description}" data-is="atom-anchorify" text="{event.raffle_rule.description}"></div> </div> <div class="text-center ts-ps text-gray_60 mb34" if="{!event.raffle_rule.close_at_display_disabled}">抽選受付終了日: {dayjs(event.raffle_rule.close_at).format(\'YYYY年M月D日 HH時mm分\')}</div> <div class="f fc w-full"> <button class="button primary raffle word-break-all" type="button" onclick="{onDraw}" disabled="{isJoined()}">{event.raffle_rule.button_text}</button> </div> </div> <div if="{isAfterPeriod}"> <div class="ts-hs">本キャンペーンの抽選期間が過ぎました</div> </div> </div> <div if="{hasResult()}"> <div class="w-full mb24 {\'square\': !refs.result_image.complete}" if="{event.drew_raffle_result_pattern.image_url}"><img class="block w-full object-fit-contain" ref="result_image" riot-src="{event.drew_raffle_result_pattern.image_url}" alt="メイン画像" onload="{_.noop}"></div> <div class="text-center mb16"> <div class="ts-ps text-gray_80" if="{event.drew_raffle_result_pattern.description}" data-is="atom-anchorify" text="{event.drew_raffle_result_pattern.description}"> </div> </div> <div if="{!event.drew_raffle_result_pattern.is_fallback}"> <div class="f fc w-full"> <button class="button primary size-l" type="button" onclick="{onGoGift}">{event.drew_raffle_result_pattern.button_text}</button> </div> </div> <div if="{event.drew_raffle_result_pattern.is_fallback}"></div> </div> </div> <module-footer class="container-538 pt16 mta" event="{event}" is-hide-terms="{true}"></module-footer> </div> </div>', 'page-raffle_events-single,[data-is="page-raffle_events-single"]{display:block}', '', function(opts) {

    const MAX_DURATION = 30000;

    const WAIT_DURATION = 2000;

    this.preload = async ({req}) => {

      const onetime_hash = req.query.hash;
      if (!onetime_hash) throw { status: 404 };
      return this.load(onetime_hash);
    };

    this.on('show', () => {

      if (!this.hasResult() && this.event.joined_at) {
        this.openIndicator({description: 'しばらく経っても更新されない場合\nリロードしてください'});
        this.pollingEvent();
      }
    });

    this.load = async (onetime_hash) => {
      try {

        const event = await app.api.child('raffle_event').get({ onetime_hash });
        return {
          event,
          onetimeHash: onetime_hash,
          isAfterPeriod: dayjs().isAfter(event.raffle_rule.close_at),
        };
      }
      catch(e) {
        if (e.status === 404) {
          e.customMessage = '有効期限がきれているか、受取済みの可能性があります。';
        }
        throw e;
      }
    };

    this.reload = async () => {
      if (this.isReloading) return ;
      this.isReloading = true;
      this.openIndicator();

      try {
        const data = await this.load(this.onetimeHash);
        this.update(data);
      }
      catch (e) {
        console.error(e);
        spat.modal.open('modal-error', {statusCode: e.status, error: e});
      }
      finally {
        this.closeIndicator();
        this.isReloading = false;
      }
    };

    this.onDraw = async () => {
      this.drawButtonClicked = true;

      this.openIndicator({description: 'しばらく経っても更新されない場合\nリロードしてください'});

      try {
        await app.api.child('raffle_event').child('dispatch').post({ onetime_hash: this.onetimeHash });
        await this.pollingEvent();
      }
      catch (e) {
        console.error(e);
        spat.modal.open('modal-error', {statusCode: e.status});
        this.drawButtonClicked = false;

        this.closeIndicator();
      }
    };

    this.pollingEvent = async () => {
      for (let start_time = Date.now(); Date.now() - start_time < MAX_DURATION;) {
        await app.utils.wait(WAIT_DURATION);

        try {
          const data = await this.load(this.onetimeHash);
          this.update(data);

          if (this.hasResult()) {
            this.closeIndicator();
            return;
          }
        }

        catch (e) {
          console.error(e);
          spat.modal.open('modal-error', {statusCode: e.status, error: e});
          this.closeIndicator();
          return;
        }
      }

      this.closeIndicator();
      spat.modal.alert('時間をおいて再度アクセスしてください。お手数おかけし誠に申し訳ございません。');
    };

    this.onGoGift =  () => {
      spat.router.push(`/gift?hash=${this.event.distribution_event_onetime_hash}`);
    };

    this.isJoined = () => {
      return this.event.joined_at || this.drawButtonClicked;
    };

    this.hasResult = () => {

      const result_pattern = this.event.drew_raffle_result_pattern;
      if (!result_pattern) return false;

      if (result_pattern.is_fallback) return true;

      return !!this.event.distribution_event_onetime_hash;
    };

    this.closeIndicator = () => {
      this.indicator.close();
      this.indicator = null;
    };

    this.openIndicator = ({ title='', description='' }={}) => {

      if (this.indicator) return ;

      this.indicator = spat.modal.open('modal-indicator', { title, description });
    };
});